// ! this is inlined in the print-helper app
export const printHelperPorts = [
  9101, 9104, 9107, 9111, 9113, 9416, 9419, 9422, 9425, 9428, 7606, 7613, 7616,
  7623, 7634,
];
